import MapleStory from 'maplestory/dist/bundle'

const instance = new MapleStory({
  Endpoint: 'https://store.senpai.dev'
})
export default instance
